import React, { Component } from "react";
import "../../assets/css/main.css";
import TelemetryLogPanel from "./Components/TelemetryLogPanel";


export default class TelemetryPage extends Component {
    constructor(props) {
        super(props);

        this.state = {

        }

    }

    // #Orgconfig removed for testing
    componentDidMount() 
    {

    }

    render() {

        return (

            <div width="-webkit-fill-available" height="100%">
            <TelemetryLogPanel 
                userSession={this.props.userSession}
                onErrorPageRequest={this.props.onErrorPageRequest}
                userSessionKey={this.props.userSessionKey} // used to trigger changes
                onToastRequest={this.props.onToastRequest}
                onMsgBoxRequest={this.props.onMsgBoxRequest}
                onHomePageRequest={this.props.onHomePageRequest}
                onLogoutRequest={this.props.onLogoutRequest}
            />
            </div>
        )
    }

}